import React from "react";
import "./UpcomingPayment.css";

const UpcomingSubscription = ({ basePlan, isWaived }) => {
  const basePrice = basePlan?.baseplanPrice || 0;
  const additionalUsers = basePlan?.additionalUser || 0;
  const pricePerUser = basePlan?.pricePerAdditionalUser || 0;
  // The one-time setup fee is charged ONCE at signup (it shows in Payment
  // History), so it is intentionally excluded from the recurring Next Invoice.
  const tax = basePlan?.tax || 0;
  // Backend now returns totalPrice as the recurring total (base + additional
  // users + tax), matching the client-side Next Invoice screen.
  const totalPrice = basePlan?.totalPrice || 0;
  const nextBillingDate = basePlan?.nextBillingDate
    ? new Date(basePlan.nextBillingDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "N/A";
  const waivedEndDate = basePlan?.waivedEndDate
    ? new Date(basePlan.waivedEndDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;

  return (
    <div className="upcomingContainer">
      <div className="upcomingHeader">
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <h5 className="upcomingTitle">Next Invoice</h5>
          {isWaived && (
            <span className="waivedBadge">Waived until {waivedEndDate}</span>
          )}
        </div>
        <span className="upcomingBillingDate">
          {isWaived ? "Next Invoice" : "Payment Due"}:{" "}
          {isWaived ? waivedEndDate : nextBillingDate}
        </span>
      </div>

      <div className="upcomingRow">
        <span>Base Plan:</span>
        <span className="upcomingValue">${basePrice}</span>
      </div>

      <div className="upcomingRow">
        <span>Additional Users:</span>
        <span className="upcomingValue">{additionalUsers}</span>
      </div>

      <div className="upcomingRow">
        <span>Additional Per User:</span>
        <span className="upcomingValue">
          ${(additionalUsers * pricePerUser).toFixed(2)}
        </span>
      </div>

      <div className="upcomingRow">
        <span>Tax:</span>
        <span className="upcomingValue">${tax.toFixed(2)}</span>
      </div>

      <div className="upcomingTotalRow">
        <span className="upcomingTotalLabel">Total Amount Due:</span>
        <span className="upcomingTotalValue">${totalPrice.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default UpcomingSubscription;
